import { RoutePaths } from './routes';
import { NavLink } from '../models/header';

export const links: NavLink[] = [
  { name: 'Home', route: RoutePaths.HOME, isActive: true },
  { name: 'Articles', route: RoutePaths.NEWS, isActive: false },
  { name: 'FAQs', route: RoutePaths.FAQ, isActive: false },
  { name: 'Contact', route: RoutePaths.CONTACT, isActive: false },
];
